import { useEffect, useMemo, useState } from "react";
import { getProfile, updateSelf } from "../../api/UserAPI";
import { useLanguage } from "../../stores/LanguageStore";
import { useProfileStore, useSessionStore } from "../../stores/UserStore";
import { MainLayout } from "../../layouts/MainLayout";
import { useNavigate } from "react-router-dom";
import { getFields } from "../../api/ContactAPI";
import { useUIStore } from "../../stores/UIStore";
import { Box } from "@mui/material";
import FallbackPage from "../unprotected/errors/FallbackPage";
import {
  getOtherPrms,
  getStatusCustom,
  getStatusSystem,
} from "../../api/PRMAPI";
import { getGlobalReport } from "../../api/ReportingAPI";
import { getEmails, getLinkedinAccounts } from "../../api/EmailAPI";
import { getFiles } from "../../api/FIleAPI";
import { getTags } from "../../api/TagsAPI";
import { getBlacklists } from "../../api/BlacklistAPI";
import { useFlowStore } from "../../stores/WorkflowStore";

const params = [
  {
    url: "activate",
    value: "api_key",
  },
  {
    url: "disableNav",
    value: "disable_nav",
  },
  {
    url: "disableHeading",
    value: "disable_heading",
  },
  {
    url: "disableActions",
    value: "disable_actions",
  },
  {
    url: "disableMobile",
    value: "disable_mobile",
  },
  {
    url: "disableSelections",
    value: "disable_selections",
  },
  {
    url: "allowSwitch",
    value: "allow_switch",
  },
];

const Protected = () => {
  const reseller = useSessionStore((state) => state.reseller);
  const session = useSessionStore((state) => state.session);
  document.title = ` ${reseller.name}`;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const apiKey = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let storedKey = localStorage.getItem("api_key")
      ? localStorage.getItem("api_key")
      : null;
    return urlParams.get("apiKey") || (storedKey !== "null" ? storedKey : null);
  }, []);

  useEffect(() => {
    //#region Part disable
    document.body.style.overflow = "auto";
    const urlParams = new URLSearchParams(window.location.search);

    params.forEach((p) => {
      let v = urlParams.get(p.url);
      if (p.url === "allowSwitch") {
        localStorage.setItem(p.value, v ? v : "false");
      } else {
        localStorage.setItem(p.value, v ? v : localStorage.getItem(p.value));
      }
    });

    if (urlParams.get("activate") === "true") {
      localStorage.setItem("api_key", urlParams.get("apiKey"));
    }

    if (urlParams.get("clearAll") === "true") {
      params.forEach((p) => {
        localStorage.setItem(p.value, false);
      });
    }
    //#endregion

    const setWindowLoading = useUIStore.getState().setWindowLoading;
    setWindowLoading(true);
    const setMainLoading = useUIStore.getState().setMainLoading;
    const setAsideLoading = useUIStore.getState().setAsideLoading;
    setMainLoading(false);
    if (!apiKey && !session) {
      console.log("no session found");

      return navigate(
        `/login?destination=${
          window.location.pathname !== "/login" ? window.location.pathname : "/"
        }&reason=NO_SESSION`,
      );
    }
    getProfile(null, false)
      .then(async (p) => {
        let new_profile = p.data.user_profile;
        const unswitchedProfile = useProfileStore.getState().unswitchedProfile;
        const setProfile = useProfileStore.getState().setProfile;
        setProfile(new_profile);

        if (new_profile?.show_new_workflow_builder === true) {
          useFlowStore.getState().setLayout("horizontal");
        }

        if (useSessionStore.getState().user_switch) {
          await useLanguage
            .getState()
            .changeLanguage(unswitchedProfile?.language);
        } else {
          await useLanguage.getState().changeLanguage(new_profile?.language);
        }
        // Chatwoot user
        // window.$chatwoot.setCustomAttributes({
        //   accountId: new_profile.id,
        //   userPayant: new_profile.subscriptions.subscription_id,
        // });
        window.$chatwoot?.setUser(new_profile.id, {
          email: new_profile.email,
          name: `${new_profile.first_name} ${new_profile.last_name}`,
        });

        updateSelf(true);
      })
      .finally(() => {
        setLoading(false);
        setWindowLoading(false);
        setAsideLoading(true);
      });

    getFields();
    getOtherPrms();
    getGlobalReport();
    getStatusSystem();
    getStatusCustom();
    getEmails();
    getLinkedinAccounts();
    getFiles();
    getTags();
    getBlacklists();
    // Community Auto join
    const team_code = urlParams.get("team_code");
    const organization_code = urlParams.get("organization_code");
    if (team_code || organization_code) {
      navigate(
        `/community/join?team_code=${team_code || ""}&organization_code=${
          organization_code || ""
        }`,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box position={"relative"}>
      <FallbackPage />
      {!loading && <MainLayout />}
    </Box>
  );
};

export default Protected;
